import { toggleButtonClasses, toggleButtonGroupClasses } from '@mui/material';

import type { Styles } from 'src/theme/themes';

export const styles = {
  modalRoot: {
    '& [role=dialog]': {
      padding: 0,
      margin: 0,
      overflow: 'hidden',
      height: 'calc(100vh - 44px)',
      maxWidth: '1440px',
    },
  },
  modalHeader: (theme) => ({
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    paddingBlock: theme.spacing(2),
    paddingInline: theme.spacing(4),
    borderBottom: 'solid 1px',
    borderColor: theme.colors.neutral[100],
  }),
  scrollContainer: {
    overflow: 'scroll',
    height: '100%',
  },
  modalMain: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.neutral[50],
    padding: theme.spacing(4),
    gap: 3,
    flexGrow: 1,
  }),
  modalSection: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: theme.colors.neutral[200],
    borderRadius: theme.spacing(1),
    padding: 2,
  }),
  sidebarSection: (theme) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  }),
  ticketDetailBox: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  }),
  ticketDetailBoxValue: (theme) => ({
    color: theme.colors.neutral[600],
    display: 'flex',
    gap: theme.spacing(1),
  }),
  feedbackGrid: (theme) => ({
    display: 'grid',
    rowGap: theme.spacing(3),
    columnGap: theme.spacing(2),
    gridTemplateColumns: 'max-content 1fr',
  }),
  feedbackDataRow: {
    display: 'grid',
    gridTemplateColumns: 'subgrid',
    gridColumn: '1 / 3',
    alignItems: 'center',
    columnGap: 2,
  },
  npsScoreBox: (theme) => ({
    width: 'min-content',
    paddingBlock: theme.spacing(0.5),
    paddingInline: theme.spacing(0.75),
    border: '2px solid',
    borderColor: theme.colors.neutral[600],
    backgroundColor: theme.colors.neutral[50],
    borderRadius: theme.spacing(0.5),
  }),
  npsScoreBoxDetractor: (theme) => ({
    borderColor: theme.colors.warning[600],
    backgroundColor: theme.colors.warning[50],
  }),
  npsScoreBoxPromoter: (theme) => ({
    borderColor: theme.colors.success[600],
    backgroundColor: theme.colors.success[50],
  }),
  orgUnitChip: (theme) => ({
    paddingBlock: theme.spacing(0.25),
    height: 'max-content',
  }),
  formTextarea: {
    backgroundColor: 'white',
  },
  toggleButtonGroup: (theme) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    columnGap: 2,
    rowGap: 1,
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      borderRadius: theme.spacing(0.5),
    },
  }),
  toggleButton: (theme) => ({
    border: 'none',
    backgroundColor: theme.colors.neutral[200],
    color: theme.colors.neutral[600],
    paddingY: theme.spacing(0.5),
    whiteSpace: 'wrap',
    [`&.${toggleButtonClasses.selected}`]: {
      backgroundColor: theme.colors.secondary[400],
      color: '#000',
      '&:hover': {
        backgroundColor: theme.colors.secondary[200],
      },
    },
  }),
} satisfies Styles;
